import React from "react";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  action,
  product,
  serviceFee,
  setServiceFee,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 w-[400px] shadow-lg">
        <h2 className="text-lg font-bold mb-4">Confirm {action}</h2>

        <p className="text-gray-700 mb-4">
          Are you sure you want to {action.toLowerCase()}{" "}
          <span className="font-semibold">{product?.name || "this company"}</span>?
        </p>

        {/* ✅ NEW: Service Fee Input */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-600 mb-2">
            Service Fee (%)
          </label>
          <input
            type="number"
            value={serviceFee}
            onChange={(e) => setServiceFee(e.target.value)}
            placeholder="Enter service fee"
            className="w-full border rounded-lg px-4 py-2 text-sm outline-none focus:ring-1 focus:ring-green-500"
          />
        </div>

        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded-lg ${
              action === "Approve"
                ? "bg-green-600 text-white hover:bg-green-700"
                : "bg-red-600 text-white hover:bg-red-700"
            }`}
          >
            {action}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;

// import React from "react";

// const ConfirmationModal = ({ isOpen, onClose, onConfirm, action, product }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//       <div className="bg-white rounded-lg p-6 w-[400px] shadow-lg">
//         <h2 className="text-lg font-bold mb-4">Confirm {action}</h2>
//         <p className="text-gray-700 mb-6">
//           Are you sure you want to {action.toLowerCase()}{" "}
//           <span className="font-semibold">{product?.title}</span>?
//         </p>
//         <div className="flex justify-end gap-4">
//           <button
//             onClick={onClose}
//             className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={onConfirm}
//             className={`px-4 py-2 rounded-lg ${
//               action === "Approve"
//                 ? "bg-green-600 text-white hover:bg-green-700"
//                 : "bg-red-600 text-white hover:bg-red-700"
//             }`}
//           >
//             {action}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ConfirmationModal;
